<template>
  <!--
    	作者：luoyiming
    	时间：2020-06-20
    	描述：diy组件-模拟显示-微信直播
    -->
  <div class="drag optional" :class="{ selected: index === selectedIndex }"
    @click.stop="$parent.$parent.onEditer(index)">
    <div class="diy-wxlive">
      <ul class="wxlive-list d-s-c f-w" :style="getUlwidth(item)">
        <li class="item">
          <div class="box d-b-c">
            <div class="pic">
              <img src="../../../../../../static/imgs/wxlivein.png" />
            </div>
            <div>店家正在直播、折扣套餐秒杀中</div>
            <div >进入</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="btn-edit-del">
      <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">{{$t('删除')}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        /*菜品列表*/
        tableData: [],
        /*分类id*/
        category_id: 0
      };
    },
    created() {},
    props: ['item', 'index', 'selectedIndex'],
    methods: {
      /*计算宽度*/
      getUlwidth(item) {
        if (item.style.display == 'slide') {
          let total = 0;
          if (item.params.source == 'choice') {
            total = item.data.length;
          } else {
            total = item.defaultData.length;
          }
          let w = 0;
          if (item.style.column == 2) {
            w = total * 150;
          } else {
            w = total * 100;
          }
          return 'width:' + w + 'px;';
        }
      }
    }
  };
</script>

<style>
  .diy-wxlive {}

  .diy-wxlive .wxlive-head {
    height: 40px;
  }

  .diy-wxlive .wxlive-head .name {
    font-size: 18px;
    font-weight: bold;
  }

  .diy-wxlive .wxlive-list {}

  .diy-wxlive .wxlive-list .item {
    width: 100%;
  }

  .diy-wxlive .wxlive-list .item .box {
    margin: 15px;
    background-color: #FFFFFF;
  }

  .diy-wxlive .wxlive-list .item img {
    width: 75px;
    height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/Wxlive.vue